// src/components/estimation/detailed/steps/form/formItem.tsx

interface FormItemProps {
  label: string;
  value?: {
    selected: boolean;
    value?: number;
  };
  onChange: (value: { selected: boolean; value?: number }) => void;
  withDistance?: boolean;
  withSurface?: boolean;
  withQuantity?: boolean;
  withLength?: boolean;
  withVolume?: boolean;
  withCapacity?: boolean;
  withCustomAmount?: boolean;
}

export const FormItem: React.FC<FormItemProps> = ({
  label,
  value = { selected: false }, // Provide default value
  onChange,
  withDistance,
  withSurface,
  withQuantity,
  withLength,
  withVolume,
  withCapacity,
  withCustomAmount,
}) => {
  // Déterminer l'unité en fonction du type
  const getUnit = () => {
    if (withDistance) return 'm';
    if (withSurface) return 'm²';
    if (withLength) return 'ml';
    if (withVolume) return 'm³';
    if (withCapacity) return 'L';
    if (withQuantity) return 'unité(s)';
    if (withCustomAmount) return '€';
    return '';
  };

  return (
    <div className="space-y-2">
      <label className="flex items-start space-x-3">
        <input
          type="checkbox"
          checked={value.selected}
          onChange={(e) => onChange({ ...value, selected: e.target.checked })}
          className="mt-1 h-4 w-4 rounded border-neutral-300 text-primary focus:ring-primary"
        />
        <span className="text-neutral-700">{label}</span>
      </label>

      {value.selected && (withDistance || withSurface || withQuantity || withLength || withVolume || withCapacity) && (
        <div className="ml-8 flex items-center space-x-2">
          <input
            type="number"
            value={value.value || ''}
            onChange={(e) => onChange({ ...value, value: Number(e.target.value) || 0 })}
            min="0"
            step={withSurface || withLength || withVolume || withDistance ? "0.1" : "1"}
            className="input w-32"
            placeholder={`Saisir en ${getUnit()}`}
          />
          <span className="text-sm text-neutral-500">{getUnit()}</span>
        </div>
      )}
      
      {value.selected && withCustomAmount && (
        <div className="ml-8 flex items-center space-x-2">
          <input
            type="number"
            value={value.value || ''}
            onChange={(e) => onChange({ ...value, value: Number(e.target.value) || 0 })}
            min="0"
            step="1"
            className="input w-32"
            placeholder="Montant en euros"
          />
          <span className="text-sm text-neutral-500">{getUnit()}</span>
        </div>
      )}
    </div>
  );
};

export default FormItem;
